// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.App {
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #f5f5f5;
}

.container {
  background: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  max-width: 600px;
  width: 100%;
  margin: 2rem;
}

/* Typography */
h1,
h2,
h3,
h4 {
  margin-top: 0;
  color: #333;
}

h1 {
  font-size: 2rem;
  margin-bottom: 1.5rem;
}

h2 {
  font-size: 1.5rem;
  margin-bottom: 1rem;
}

/* Buttons */
button {
  padding: 0.75rem 1.5rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: all 0.2s;
}

button:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.continue-button,
.confirm-deletion-button {
  background-color: #007bff;
  color: white;
}

.continue-button:hover:not(:disabled),
.confirm-deletion-button:hover:not(:disabled) {
  background-color: #0056b3;
}

.cancel-button {
  background-color: #6c757d;
  color: white;
  margin-right: 1rem;
}

.cancel-button:hover:not(:disabled) {
  background-color: #545b62;
}

/* Forms */
.form-group {
  margin-bottom: 1rem;
}

.form-group label {
  display: block;
  margin-bottom: 0.5rem;
  font-weight: 500;
  color: #333;
}

.form-group input {
  width: 100%;
  padding: 0.5rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
}

.form-group input:focus {
  outline: none;
  border-color: #007bff;
}

/* Landing Page */
.landing-page {
  text-align: center;
}

.warning-content {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  border-radius: 4px;
  padding: 1.5rem;
  margin: 1.5rem 0;
  text-align: left;
}

.warning-content ul {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
}

/* Login Form */
.login-form {
  max-width: 400px;
  margin: 0 auto;
}

.password-reset-link {
  display: inline-block;
  margin-top: 1rem;
  color: #007bff;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
  cursor: pointer;
  text-decoration: underline;
}

.password-reset-link:hover {
  text-decoration: none;
}

.error-message {
  color: #dc3545;
  margin: 0.5rem 0;
  font-size: 0.9rem;
}

/* Deletion Checklist */
.checklist {
  margin: 1.5rem 0;
}

.checklist-item {
  display: flex;
  align-items: center;
  margin-bottom: 1rem;
  cursor: pointer;
}

.checklist-item input[type='checkbox'] {
  margin-right: 0.75rem;
  width: auto;
}

.additional-info {
  background-color: #f8f9fa;
  padding: 1rem;
  border-radius: 4px;
  margin: 1.5rem 0;
}

.additional-info details {
  margin-bottom: 1rem;
}

.additional-info summary {
  cursor: pointer;
  font-weight: 500;
  color: #007bff;
}

.data-details {
  margin-top: 1rem;
  padding-left: 1rem;
}

.data-details h4 {
  margin: 1rem 0 0.5rem;
  font-size: 1rem;
}

.data-details ul {
  margin: 0;
  padding-left: 1.5rem;
}

.timeline-info {
  margin-top: 1rem;
  font-size: 0.95rem;
}

.button-group {
  display: flex;
  justify-content: flex-end;
  margin-top: 2rem;
}

/* Final Confirmation */
.warning-box {
  background-color: #f8d7da;
  border: 2px solid #dc3545;
  border-radius: 4px;
  padding: 1.5rem;
  margin-bottom: 2rem;
}

.warning-box h2 {
  color: #dc3545;
  margin-bottom: 1rem;
}

.warning-box ul {
  margin: 0.5rem 0;
  padding-left: 1.5rem;
}

.confirmation-input {
  margin: 2rem 0;
}

.confirmation-input input {
  width: 100%;
  padding: 0.75rem;
  border: 2px solid #ddd;
  border-radius: 4px;
  font-size: 1.1rem;
  text-align: center;
  text-transform: uppercase;
}

.confirmation-input input:focus {
  border-color: #dc3545;
}

.confirm-deletion-button {
  background-color: #dc3545;
}

.confirm-deletion-button:hover:not(:disabled) {
  background-color: #c82333;
}

/* Confirmation Page */
.success-message {
  text-align: center;
  margin-bottom: 2rem;
}

.success-message h1 {
  color: #28a745;
}

.request-details {
  background-color: #f8f9fa;
  padding: 1.5rem;
  border-radius: 4px;
  margin: 1.5rem 0;
}

.request-details dl {
  margin: 0;
}

.request-details dt {
  font-weight: 600;
  margin-top: 0.75rem;
}

.request-details dt:first-child {
  margin-top: 0;
}

.request-details dd {
  margin: 0.25rem 0 0.75rem 0;
}

.next-steps ul {
  padding-left: 1.5rem;
}

.contact-info {
  background-color: #e7f3ff;
  padding: 1rem;
  border-radius: 4px;
  margin: 1.5rem 0;
}

.notice {
  background-color: #fff3cd;
  border: 1px solid #ffeaa7;
  padding: 1rem;
  border-radius: 4px;
  margin-top: 1.5rem;
}
`, "",{"version":3,"sources":["webpack://./src/App.css"],"names":[],"mappings":"AAAA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,WAAW;EACX,YAAY;AACd;;AAEA,eAAe;AACf;;;;EAIE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,eAAe;EACf,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,uBAAuB;EACvB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;;EAEE,yBAAyB;EACzB,YAAY;AACd;;AAEA;;EAEE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,UAAU;AACV;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,eAAe;EACf,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA,iBAAiB;AACjB;EACE,kBAAkB;AACpB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,gBAAgB;EAChB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA,eAAe;AACf;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,qBAAqB;EACrB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,YAAY;EACZ,UAAU;EACV,aAAa;EACb,eAAe;EACf,0BAA0B;AAC5B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,uBAAuB;AACvB;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,qBAAqB;EACrB,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA,uBAAuB;AACvB;EACE,yBAAyB;EACzB,yBAAyB;EACzB,kBAAkB;EAClB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;EAClB,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,yBAAyB;EACzB,eAAe;EACf,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,2BAA2B;AAC7B;;AAEA;EACE,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,yBAAyB;EACzB,aAAa;EACb,kBAAkB;EAClB,kBAAkB;AACpB","sourcesContent":[".App {\n  min-height: 100vh;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background-color: #f5f5f5;\n}\n\n.container {\n  background: white;\n  padding: 2rem;\n  border-radius: 8px;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  max-width: 600px;\n  width: 100%;\n  margin: 2rem;\n}\n\n/* Typography */\nh1,\nh2,\nh3,\nh4 {\n  margin-top: 0;\n  color: #333;\n}\n\nh1 {\n  font-size: 2rem;\n  margin-bottom: 1.5rem;\n}\n\nh2 {\n  font-size: 1.5rem;\n  margin-bottom: 1rem;\n}\n\n/* Buttons */\nbutton {\n  padding: 0.75rem 1.5rem;\n  border: none;\n  border-radius: 4px;\n  font-size: 1rem;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\nbutton:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.continue-button,\n.confirm-deletion-button {\n  background-color: #007bff;\n  color: white;\n}\n\n.continue-button:hover:not(:disabled),\n.confirm-deletion-button:hover:not(:disabled) {\n  background-color: #0056b3;\n}\n\n.cancel-button {\n  background-color: #6c757d;\n  color: white;\n  margin-right: 1rem;\n}\n\n.cancel-button:hover:not(:disabled) {\n  background-color: #545b62;\n}\n\n/* Forms */\n.form-group {\n  margin-bottom: 1rem;\n}\n\n.form-group label {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n  color: #333;\n}\n\n.form-group input {\n  width: 100%;\n  padding: 0.5rem;\n  border: 1px solid #ddd;\n  border-radius: 4px;\n  font-size: 1rem;\n}\n\n.form-group input:focus {\n  outline: none;\n  border-color: #007bff;\n}\n\n/* Landing Page */\n.landing-page {\n  text-align: center;\n}\n\n.warning-content {\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  border-radius: 4px;\n  padding: 1.5rem;\n  margin: 1.5rem 0;\n  text-align: left;\n}\n\n.warning-content ul {\n  margin: 0.5rem 0;\n  padding-left: 1.5rem;\n}\n\n/* Login Form */\n.login-form {\n  max-width: 400px;\n  margin: 0 auto;\n}\n\n.password-reset-link {\n  display: inline-block;\n  margin-top: 1rem;\n  color: #007bff;\n  background: none;\n  border: none;\n  padding: 0;\n  font: inherit;\n  cursor: pointer;\n  text-decoration: underline;\n}\n\n.password-reset-link:hover {\n  text-decoration: none;\n}\n\n.error-message {\n  color: #dc3545;\n  margin: 0.5rem 0;\n  font-size: 0.9rem;\n}\n\n/* Deletion Checklist */\n.checklist {\n  margin: 1.5rem 0;\n}\n\n.checklist-item {\n  display: flex;\n  align-items: center;\n  margin-bottom: 1rem;\n  cursor: pointer;\n}\n\n.checklist-item input[type='checkbox'] {\n  margin-right: 0.75rem;\n  width: auto;\n}\n\n.additional-info {\n  background-color: #f8f9fa;\n  padding: 1rem;\n  border-radius: 4px;\n  margin: 1.5rem 0;\n}\n\n.additional-info details {\n  margin-bottom: 1rem;\n}\n\n.additional-info summary {\n  cursor: pointer;\n  font-weight: 500;\n  color: #007bff;\n}\n\n.data-details {\n  margin-top: 1rem;\n  padding-left: 1rem;\n}\n\n.data-details h4 {\n  margin: 1rem 0 0.5rem;\n  font-size: 1rem;\n}\n\n.data-details ul {\n  margin: 0;\n  padding-left: 1.5rem;\n}\n\n.timeline-info {\n  margin-top: 1rem;\n  font-size: 0.95rem;\n}\n\n.button-group {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 2rem;\n}\n\n/* Final Confirmation */\n.warning-box {\n  background-color: #f8d7da;\n  border: 2px solid #dc3545;\n  border-radius: 4px;\n  padding: 1.5rem;\n  margin-bottom: 2rem;\n}\n\n.warning-box h2 {\n  color: #dc3545;\n  margin-bottom: 1rem;\n}\n\n.warning-box ul {\n  margin: 0.5rem 0;\n  padding-left: 1.5rem;\n}\n\n.confirmation-input {\n  margin: 2rem 0;\n}\n\n.confirmation-input input {\n  width: 100%;\n  padding: 0.75rem;\n  border: 2px solid #ddd;\n  border-radius: 4px;\n  font-size: 1.1rem;\n  text-align: center;\n  text-transform: uppercase;\n}\n\n.confirmation-input input:focus {\n  border-color: #dc3545;\n}\n\n.confirm-deletion-button {\n  background-color: #dc3545;\n}\n\n.confirm-deletion-button:hover:not(:disabled) {\n  background-color: #c82333;\n}\n\n/* Confirmation Page */\n.success-message {\n  text-align: center;\n  margin-bottom: 2rem;\n}\n\n.success-message h1 {\n  color: #28a745;\n}\n\n.request-details {\n  background-color: #f8f9fa;\n  padding: 1.5rem;\n  border-radius: 4px;\n  margin: 1.5rem 0;\n}\n\n.request-details dl {\n  margin: 0;\n}\n\n.request-details dt {\n  font-weight: 600;\n  margin-top: 0.75rem;\n}\n\n.request-details dt:first-child {\n  margin-top: 0;\n}\n\n.request-details dd {\n  margin: 0.25rem 0 0.75rem 0;\n}\n\n.next-steps ul {\n  padding-left: 1.5rem;\n}\n\n.contact-info {\n  background-color: #e7f3ff;\n  padding: 1rem;\n  border-radius: 4px;\n  margin: 1.5rem 0;\n}\n\n.notice {\n  background-color: #fff3cd;\n  border: 1px solid #ffeaa7;\n  padding: 1rem;\n  border-radius: 4px;\n  margin-top: 1.5rem;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
